import scssVariables from 'styles/sass-variables.module.scss';

export const textSwitcherStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '4px',
  gap: '8px',
  fontFamily: 'Plus Jakarta Sans, Manrope',
  textTransform: 'uppercase',
  border: '1px solid #DCDCE4',
  borderRadius: '8px',
  fontWeight: 'bold',
  color: scssVariables.text_primary,
};

export const textSwitcherButtonStyle = {
  padding: '8px 28px',
  borderRadius: '6px',
  border: '1px solid transparent',
  minWidth: '120px',
  width: '100%',
  cursor: 'pointer',
  textAlign: 'center',
  fontSize: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '32px',
};

export const getColorStyles = (isSwitcherOn: boolean) => ({
  color: isSwitcherOn ? `${scssVariables.brand_grey_default}` : `${scssVariables.text_primary}`,
  borderColor: isSwitcherOn ? `${scssVariables.brand_grey_light_200}` : 'transparent',
  backgroundColor: isSwitcherOn ? `${scssVariables.white}` : 'transparent',
});
